module.exports = __webpack_public_path__ + "img/flowers.cb8236ba.jpg";